import { founded_item } from "./index.js";
import { central_or_parallelDeserializeStep } from "./index.js";
import { cartesian_point } from "./index.js";
import { planar_box } from "./index.js";
/* This is generated code, don't modify */
import EntityTypesAP214 from "./entity_types_ap214.gen.js";
///**
// *  */
export class view_volume extends founded_item {
    get type() {
        return EntityTypesAP214.VIEW_VOLUME;
    }
    get projection_type() {
        if (this.projection_type_ === void 0) {
            this.projection_type_ = this.extractLambda(0, central_or_parallelDeserializeStep, false);
        }
        return this.projection_type_;
    }
    get projection_point() {
        if (this.projection_point_ === void 0) {
            this.projection_point_ = this.extractElement(1, false, cartesian_point);
        }
        return this.projection_point_;
    }
    get view_plane_distance() {
        if (this.view_plane_distance_ === void 0) {
            this.view_plane_distance_ = this.extractNumber(2, false);
        }
        return this.view_plane_distance_;
    }
    get front_plane_distance() {
        if (this.front_plane_distance_ === void 0) {
            this.front_plane_distance_ = this.extractNumber(3, false);
        }
        return this.front_plane_distance_;
    }
    get front_plane_clipping() {
        if (this.front_plane_clipping_ === void 0) {
            this.front_plane_clipping_ = this.extractBoolean(4, false);
        }
        return this.front_plane_clipping_;
    }
    get back_plane_distance() {
        if (this.back_plane_distance_ === void 0) {
            this.back_plane_distance_ = this.extractNumber(5, false);
        }
        return this.back_plane_distance_;
    }
    get back_plane_clipping() {
        if (this.back_plane_clipping_ === void 0) {
            this.back_plane_clipping_ = this.extractBoolean(6, false);
        }
        return this.back_plane_clipping_;
    }
    get view_volume_sides_clipping() {
        if (this.view_volume_sides_clipping_ === void 0) {
            this.view_volume_sides_clipping_ = this.extractBoolean(7, false);
        }
        return this.view_volume_sides_clipping_;
    }
    get view_window() {
        if (this.view_window_ === void 0) {
            this.view_window_ = this.extractElement(8, false, planar_box);
        }
        return this.view_window_;
    }
    constructor(localID, internalReference, model) {
        super(localID, internalReference, model);
    }
}
view_volume.query = [EntityTypesAP214.VIEW_VOLUME];
view_volume.expectedType = EntityTypesAP214.VIEW_VOLUME;
